module.exports = "/_next/static/images/find-bg-a7d10f485c5aea3c2ef0d3aeef8f92c8.svg";